export * from "./space.axialTilt";
export * from "./space.interfaces";
export * from "./space.spectralClass";
export * from "./space.starColor";
export * from "./Mechanics/index";
//# sourceMappingURL=index.js.map